// FilePreview.jsx — FASE-11 E5-WS4: casca LAZY do preview com syntax highlight.
// O Prism (react-syntax-highlighter → refractor, parte do chunk `markdown` de
// ~745K) vive em FilePreviewImpl.jsx e só baixa quando o primeiro ToolCallBlock
// de read_file/write_file expande. Este import estático era um dos DOIS que
// puxavam o chunk markdown inteiro pro boot (o outro era o MarkdownMessage).
// Fallback: <pre> plano — conteúdo visível na hora, hidrata pro highlight.
import { lazy, Suspense } from 'react';

const FilePreviewImpl = lazy(() => import('./FilePreviewImpl.jsx'));

export default function FilePreview({ path, content, variant = 'read' }) {
  return (
    <Suspense
      fallback={
        <pre className="m-0 overflow-x-auto whitespace-pre-wrap p-3 font-mono text-[12px] leading-[1.55] text-apolo-textSecondary">
          {content || ''}
        </pre>
      }
    >
      <FilePreviewImpl path={path} content={content} variant={variant} />
    </Suspense>
  );
}
